/* eslint-disable camelcase */
import { Select, IProps as SelectProps } from 'components/atoms/Select/Select.components';
import { useEffect } from 'react';
import { useGetPicklistQuery } from 'services/sap';
import { mapCatalogueItems } from 'utils/helpers';
import { catalogoPersonal, catalogoLenguage } from 'utils/helpers/dictionaries';

interface ContractTypeSelectProps extends Omit<SelectProps, 'handleChange'> {
  handleChange: (value: { value: string; externalCode: string; valueEn: string }) => void;
  name?: string;
}

export interface CatalogueItem {
  externalCode: string;
  label_es_ES: string;
  label_en_US: string;
}

export default function ContractTypeSelect({
  handleChange,
  name,
  ...rest
}: Readonly<ContractTypeSelectProps>) {
  const { data: contract, isLoading } = useGetPicklistQuery<{
    data: CatalogueItem[];
    isLoading: boolean;
  }>({
    catalogName: catalogoPersonal.contractType,
    languages: catalogoLenguage.ESyUSyISO,
  });

  const options = mapCatalogueItems(contract);

  useEffect(() => {
    if (!contract || isLoading || !rest.value) {
      return;
    }
    const contractFormat = rest.value.value.split('-');
    const selectedContract = contract?.find(
      ({ label_es_ES, externalCode }) =>
        label_es_ES === contractFormat[0] && externalCode.includes(contractFormat[1])
    );

    if (!selectedContract) {
      return;
    }

    handleChange({
      value: rest.value.value ?? '',
      externalCode: selectedContract?.externalCode ?? '',
      valueEn: selectedContract?.label_en_US ?? '',
    });
  }, [isLoading, contract])

  return (
    <Select
      handleChange={(value) => {
        if (typeof value !== 'string') {
          handleChange({ value: '', externalCode: '', valueEn: '' });
        } else {
          const contractFormat = value.split('-');
          const selectedContract = contract?.find(
            ({ label_es_ES, externalCode }) =>
              label_es_ES === contractFormat[0] && externalCode.includes(contractFormat[1])
          );

          handleChange({
            value: value?.toString() ?? '',
            externalCode: selectedContract?.externalCode ?? '',
            valueEn: selectedContract?.label_en_US ?? '',
          });
        }
      }}
      disabled={isLoading}
      options={options}
      {...rest}
    />
  );
}
